module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACPSURBVHgB7ZTtCYAgEECvaIBGaIRGcKNWaANXqElsE0ewDS4jgxC0j7uiH/dABO+8xykcwF9AROuXycR1yKmBIGlww2ZyTMhRcLN455dDGvpM0iIf6li7jFz7O0/FQ/zdMdRocqLXqBLnau0dGPmso5SI448uidgRkYhERCeedXPYOWady0Z9/R7pDCBwsQAxPRGG9WwNKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Calendar.png
// module id = dqlJ
// module chunks = 1